import PropTypes from 'prop-types';
import React from 'react';
import FluidImage from '@utility/FluidImage/index';
import FigCaption from '@utility/FigCaption';
import PortableText from '@utility/PortableText';
import Parallax from '@utility/Parallax';
import ScrollInView from '@utility/ScrollInView/index';

const ImageFullWidth = ({
  data: {
    image: { image, richText },
  },
  parallax,
  animateIn,
  className,
  loading,
}) => {
  const renderFigure = () => (
    <figure className={className}>
      {parallax ? (
        <Parallax y={[-15, 15]}>
          <FluidImage
            src={image}
            maxWidth={2880}
            maxHeight={1920}
            loading={loading}
          />
        </Parallax>
      ) : (
        <FluidImage
          src={image}
          loading={loading}
          maxWidth={2880}
          maxHeight={1920}
        />
      )}
      {richText && (
        <div className="wrapper">
          <div className="row">
            <div className="col-10 md:col-12">
              <FigCaption>
                <PortableText blocks={richText.richText} />
              </FigCaption>
            </div>
          </div>
        </div>
      )}
    </figure>
  );

  return animateIn ? (
    <ScrollInView>{renderFigure()}</ScrollInView>
  ) : (
    renderFigure()
  );
};

ImageFullWidth.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({
      image: PropTypes.shape({
        asset: PropTypes.shape({
          _id: PropTypes.string,
        }),
      }).isRequired,
      richText: PropTypes.shape({
        _type: PropTypes.string,
        richText: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
  }),
  parallax: PropTypes.bool,
  loading: PropTypes.string,
  animateIn: PropTypes.bool,
  className: PropTypes.string,
};

ImageFullWidth.defaultProps = {
  data: {
    image: {
      richText: {},
    },
  },
  parallax: true,
  animateIn: true,
  className: '',
  loading: 'lazy',
};

export default ImageFullWidth;
